module.exports = __webpack_public_path__ + "static/img/index_bg.7a3feb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg.jpg
// module id = ol0V
// module chunks = 9